<script setup lang="ts">
import { Filters } from "~/core/models/filters";
import { useFetchDtwinsMetricsFirmwareVersion } from "~/modules/dtwin/composables/useFetchDtwinsMetricsFirmwareVersion";

const props = defineProps<{
  organizationCode?: number;
  selectedSectorCodes?: number[];
  userAssignedSectorsCodes: string[];
}>();

const { t } = useI18n();
const { isLoading, error, result, fetchData, setFilter } =
  useFetchDtwinsMetricsFirmwareVersion({
    organizationCode: props.organizationCode,
  });

const selectedSectorsComputed = computed(() => {
  if (props.selectedSectorCodes && props.selectedSectorCodes.length > 0) {
    return props.selectedSectorCodes.map((sectorCode) => sectorCode.toString());
  } else {
    return props.userAssignedSectorsCodes;
  }
});

async function loadData() {
  setFilter(Filters.SECTORS, selectedSectorsComputed.value);
  await fetchData();
}

const hasResultEntriesHaveValues = computed(() => {
  if (result.value && Object.entries(result.value).length > 0) {
    return Object.values(result.value).some(
      (entry) => Object.values(entry).length > 0,
    );
  } else {
    return false;
  }
});

watch(
  () => selectedSectorsComputed.value,
  async () => await loadData(),
);

onMounted(loadData);
</script>

<template>
  <div class="col-span-2">
    <dashboard-card
      :title="t('dashboard.firmwares.title')"
      :is-loading="isLoading"
      :error="error"
    >
      <div
        v-if="hasResultEntriesHaveValues"
        class="grid lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-x-32 gap-y-8"
      >
        <dashboard-firmware-version-distribution-chart
          v-for="(firmwareDistribution, dtwinModel) in result"
          :key="dtwinModel"
          :firmware-distribution="firmwareDistribution"
          :dtwin-model="dtwinModel"
        />
      </div>
      <div v-else>
        <h6 class="text-gray-700">{{ t("dashboard.firmwares.noData") }}</h6>
      </div>
    </dashboard-card>
  </div>
</template>
